export default __webpack_public_path__ + "static/media/welcome-tour-4.b335804d.png";